import React, { useState } from "react";
import ReactDOM from "react-dom";
import VisibilitySensor from 'react-visibility-sensor/visibility-sensor'
import { Embed } from "semantic-ui-react";

const Video = ({ id }) => {
  const [visible, setVisibile] = useState(false);
  return (
    <VisibilitySensor
      onChange={isVisible => {
        if (isVisible && !visible) {
          setVisibile(true);
        }
        if (!isVisible && visible) {
          setVisibile(false);
        }
      }}
      partialVisibility
    >
      <Embed hd={false} id={id} active={visible} source="youtube" />
    </VisibilitySensor>
  );
};

export default Video;